/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructNullValue = void 0;
var StructNullValue;
(function (StructNullValue) {
    StructNullValue["NULL_VALUE"] = "NULL_VALUE";
})(StructNullValue = exports.StructNullValue || (exports.StructNullValue = {}));
//# sourceMappingURL=types.js.map